<template>
  <div class="app">
    <splitpanes class="default-theme">
      <pane size="28">
        <bd-aside></bd-aside>
      </pane>
      <pane size="45">
        <splitpanes horizontal>
          <pane size="6" min-size="6">
            <bd-top></bd-top>
          </pane>
          <pane size="79">
            <bd-message></bd-message>
          </pane>
          <pane size="15" min-size="15">
            <bd-input></bd-input>
          </pane>
        </splitpanes>
      </pane>
      <pane size="25">
        <!-- <bd-right></bd-right> -->
      </pane>
    </splitpanes>
  </div>
</template>

<script>
// https://antoniandre.github.io/splitpanes/
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
// import { Layout } from 'vue-split-layout'
import BdAside from '@/components/dashboard/main/ticket/BdAside'
// import BdMain from '@/components/dashboard/main/ticket/BdMain'
// import BdTop from '@/components/dashboard/main/ticket/children/BdTop'
// import BdMessage from '@/components/dashboard/main/ticket/children/BdMessage'
// import BdInput from '@/components/dashboard/main/ticket/children/BdInput'
// import BdRight from '@/components/dashboard/main/ticket/children/BdRight'
import BdTop from '@/components/dashboard/main/chat/middle/BdTop'
import BdMessage from '@/components/dashboard/main/chat/middle/BdMessage'
import BdInput from '@/components/dashboard/main/chat/middle/BdInput'

export default {
  name: 'bd-online',
  // components: { BdAside, BdMain, Layout }, BdRight, 
  components: { BdAside, BdTop, BdMessage, BdInput, Splitpanes, Pane },
  data () {
    return {
      // resize: true,
      // splits: {
      //   dir: 'horizontal',
      //   first: 0,
      //   second: 1,
      //   split: '30%'
      // }
    }
  }
}
</script>

<style scope>
</style>
